<template lang="pug">
.secondary.py-16.parallelogram(v-if="!loading")
  grid-container.justify-center(
    cols-md="auto auto auto auto",
    cols-sm="auto auto",
    cols-xs="auto",
    justify="center"
  )
    grid-item.mb-4(col-end-md="4", col-end-sm="2")
      .text-h4.font-weight-bold.text-center {{ title }}
    article-card.mx-auto(
      v-for="({ title, scheduled, text, img, to }, i) in items",
      :key="i",
      :title="title",
      :date="scheduled",
      :text="text",
      :img="img",
      :to="to"
    )
    grid-item.d-flex.justify-center(col-end-md="4", col-end-sm="2")
      v-btn.px-8.text-none.font-weight-bold(
        :to="viewMoreTo",
        color="primary",
        dark,
        depressed
      ) Ver mais
</template>
<script>
import ArticleCard from "@/components/cards/Article.vue";
import { formatToURL } from "@/components/utils.js";

const _config = {
  title: "ÚLTIMAS NOTÍCIAS",
  mod: "articles",
  path: "/novidades/noticias",
  itemsPerPage: {
    lgAndUp: 4,
    smOnly: 4,
    default: 3,
  },
};

export default {
  data: () => ({
    loading: true,
    viewMoreTo: _config.path,
    title: _config.title,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, title, scheduled, img, text }) => ({
          title,
          img: this.files + img,
          scheduled: scheduled || "",
          text,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
  },
  created() {
    this.loading = true;
    let itemsPerPage = null;
    for (let bp in _config.itemsPerPage) {
      if (this.$vuetify.breakpoint[bp]) {
        itemsPerPage = _config.itemsPerPage[bp];
        break;
      }
    }

    this.$rest(_config.mod)
      .get({
        params: {
          itemsPerPage: itemsPerPage || _config.itemsPerPage.default,
        },
      })
      .then((this.loading = false));
  },
  components: {
    ArticleCard,
  },
};
</script>
